export const DEFAULT_CACHE_TTL = 1000 * 60 * 60 * 1; // 1 hours
